import RadioCheckedIcon from 'assets/icons/radio-checked-icon.svg';
import RadioboxHHMTIcon from 'assets/icons/radiobox-hhmt-icon.svg';
import RadioboxRemoxIcon from 'assets/icons/radiobox-remox-icon.svg';
import { DESKTOP_MIN_WIDTH } from 'constants';
import { SELECT_CURRENCY_DENOM_NAME } from 'constants/fx';
import useLang from 'hooks/useLang';
import useTheme from 'hooks/useTheme';
import React from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

const OPTIONS = ['Mixed', 'Large', 'Small'];

const DenominationSelector = ({
  currencyCode,
  selectedDenomination = OPTIONS[0],
  handleChange,
  styles = {},
}) => {
  const { t } = useLang();
  const { isHHMTTheme } = useTheme();

  return (
    <DenominationSelectorStyled style={styles || {}}>
      <DenomLable>{t('label_denomination')}</DenomLable>
      <DenomOptions>
        {OPTIONS.map((option, index) => {
          const className = `${SELECT_CURRENCY_DENOM_NAME}-${currencyCode}-${index}`;
          return (
            <DenomItem
              key={index}
              onClick={() => handleChange(currencyCode, option)}
            >
              <FormCheck
                className={className}
                inline
                type="radio"
                label={t(`label_${option.toLowerCase()}_denom`)}
                name={SELECT_CURRENCY_DENOM_NAME + currencyCode}
                $checkboxSrc={
                  isHHMTTheme ? RadioboxHHMTIcon : RadioboxRemoxIcon
                }
                checked={selectedDenomination === option}
                readOnly={false}
              />
            </DenomItem>
          );
        })}
      </DenomOptions>
    </DenominationSelectorStyled>
  );
};

const DenominationSelectorStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0px 0px 8px 10px;
  width: 100%;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 0;
  }
`;

const DenomLable = styled.label`
  font-family: var(--ff-primary);
  font-weight: 700;
  font-size: 12px;
  color: var(--ds-c-black);

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
  }
`;

const DenomOptions = styled.div`
  display: flex;
  gap: 16px;
`;

const DenomItem = styled.span``;
const FormCheck = styled(Form.Check)`
  margin: 0;

  input {
    border: none;
    border-radius: 2px;
    background-image: ${(props) => `url(${props.$checkboxSrc}) !important`};
    background-position: center !important;
    width: 16px;
    height: 16px;
    cursor: ${(props) =>
      props.$isDisabled ? 'not-allowed !important' : 'pointer !important'};
    &:focus,
    &:active,
    &:checked {
      background-color: transparent;
      border: none;
      border-radius: 2px;
      box-shadow: none !important;
      filter: none !important;
    }
    &:checked[type='radio'] {
      background-image: url(${RadioCheckedIcon}) !important;
      background-position: center !important;
    }
  }

  label {
    font-family: var(--ff-primary);
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    color: var(--ds-c-grey-dark);
    margin-left: 0px;
    cursor: ${(props) =>
      props.$isDisabled ? 'not-allowed !important' : 'pointer !important'};
    user-select: none;
    @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
      font-size: 16px;
      line-height: 20px;
    }
  }

  &.active {
    label {
      font-weight: 700;
    }
  }
`;

export default DenominationSelector;
